"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
function CategoryGrid() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="226882" className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className={`animate-pulse ${i === 1 ? "md:mt-16" : i === 2 ? "md:mt-32" : ""}`}>
            <div className="w-full bg-muted p-4 sm:p-6">
              <div className="aspect-[4/5] w-full bg-background/50" />
            </div>
            <div className="mx-auto mt-8 h-8 w-2/3 bg-muted" />
          </div>)}
      </div>;
  }
  if (error || terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-12 md:grid-cols-3 lg:gap-16">
      {terms.slice(0, 3).map((term, i) => <div key={term.id} data-index={i} className={`group flex flex-col ${i === 1 ? "md:mt-16" : i === 2 ? "md:mt-32" : ""}`}>
          {}
          <div className="relative bg-secondary/30 p-4 transition-colors duration-700 group-hover:bg-secondary/50 sm:p-6 lg:p-8 rounded-lg shadow-sm">
            <Link to={term.link || "/ShopPage"} className="relative block overflow-hidden bg-background rounded-md">
              <AspectRatio ratio={4 / 5}>
                {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-sm text-muted-foreground font-sans">
                    Crafting...
                  </div>}
              </AspectRatio>

              {}
              <div className="absolute inset-0 flex items-center justify-center bg-primary/10 opacity-0 backdrop-blur-[2px] transition-all duration-500 group-hover:opacity-100">
                <span className="bg-background/95 px-8 py-4 text-sm font-default font-semibold tracking-widest text-primary uppercase shadow-md transition-transform duration-500 hover:scale-105">
                  Explore {term.name}
                </span>
              </div>
            </Link>
          </div>

          {}
          <h3 className="mt-8 text-center font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            {term.name}
          </h3>
        </div>)}
    </div>;
}
export default function CoastalFoundationsCollections() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 3,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="explore-our-pantry" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center md:mb-24">
          <h2 className="font-serif text-5xl font-medium tracking-tight text-foreground md:text-7xl">
            Explore Our Pantry
          </h2>
          <div className="mx-auto mt-6 h-1 w-24 bg-primary/40 rounded-full" />
          <p className="mt-8 font-default text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover our daily selection of artisan creations, from crusty sourdoughs to delicate morning pastries.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query} className="coastal-collections-provider">
          <CategoryGrid />
        </EcommerceTermsProvider>
      </div>
    </section>;
}